<div class="bg-dark">
    <footer class="bg-dark container py-3 my-4">
        <div class="d-flex align-items-center">
            <img src="./images/icons/logo_512x512.png" height="30" width="30" alt="logo">
            <span class="text-light flex-grow-1 text-center">Ezequiel Pérez, 2019-7883 - © 2021</span>
        </div>
    </footer>
</div>
